import { CSSProperties } from 'react'

import styled from 'styled-components'

export const TabItemStyle: CSSProperties = {
  flex: '1',
  textAlign: 'center',
}

export const StyledTabPager = styled.div`
  [role='tab'] span {
    font-size: 14px;
  }
`

export const TabPanelStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  marginTop: '24px',
  padding: '0px',
  gap: '24px',
}

export const MainContainerStyle: CSSProperties = {
  width: '100%',
  height: '100%',
}

export const BottomCard = styled.div`
  padding: 24px;
`
